import { render, staticRenderFns } from "./FireStoppingReportView.vue?vue&type=template&id=61520462&"
import script from "./FireStoppingReportView.vue?vue&type=script&lang=js&"
export * from "./FireStoppingReportView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports